module.exports = __webpack_public_path__ + "static/media/frontHouseNew.78833234.png";